import React, { useEffect } from "react";

import {
  FaArrowLeft,
  FaArrowRight
} from "react-icons/fa";

import "../../Style/MeetTheTeam.css";
import teamData from "../../Json/teamData.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { myCustomTheme } from "../../Theme";

import "swiper/css";
import "swiper/css/navigation";

import Team1 from "../../Assets/Kirtan-Vaddoriya.png";
import Team2 from "../../Assets/Mithil-Patoliya.png";
import Team3 from "../../Assets/Team-1.jpg";
import Team4 from "../../Assets/Karan-Dalwala.png";
import Team5 from "../../Assets/Team-3.jpg";

const MeetTheTeam = () => {

  const theme = myCustomTheme;

  // OPEN ANIMATION
  useEffect(() => {

    const section = document.querySelector(".team-fluid-bg");

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }

        });

      },
      { threshold: 0.2 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {

      if (section) {
        observer.unobserve(section);
      }

    };

  }, []);

  const images = {
    "Team-1.jpg": Team1,
    "Team-2.jpg": Team2,
    "Team-3.jpg": Team3,
    "Team-4.jpg": Team4,
    "Team-5.jpg": Team5,
  };

  return (
    <section className="team-section">

      <div className="container-fluid team-fluid-bg">

        <div className="container team-container">

          {/* TOP HEADER */}
          <div className="team-header">

            <h2
              style={{
                fontFamily: theme.typography.heading_font,
              }}
            >
              Meet The Team
            </h2>

            <h3
              style={{
                fontFamily: theme.typography.heading_font,
              }}
            >
              Our 3D Printing Specialists
            </h3>

            <p
              style={{
                fontFamily: theme.typography.text_font,
              }}
            >
              Our Team of Designers, Engineers, and 3D Printing Experts Is
              Committed to Innovation, Accuracy, and Customer Success
            </p>

          </div>

          {/* ARROWS */}
          <div className="team-arrows">

            <div className="team-prev">
              <FaArrowLeft />
            </div>

            <div className="team-next">
              <FaArrowRight />
            </div>

          </div>

          {/* SWIPER */}
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={25}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false
            }}
            navigation={{
              prevEl: ".team-prev",
              nextEl: ".team-next"
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
            }}
          >

            {teamData.map((member, index) => (
              <SwiperSlide key={member.id}>

                <div
                  className="team-card"
                  style={{
                    animationDelay: `${index * 0.2}s`
                  }}
                >

                  {/* IMAGE */}
                  <div className="team-img">

                    <img
                      src={images[member.img]}
                      alt={member.name}
                    />

                  </div>

                  {/* CARD BOTTOM */}
                  <div className="team-bottom">

                    <div className="name-row">

                      <div
                        className="team-name"
                        style={{
                          fontFamily: theme.typography.text_font,
                        }}
                      >
                        {member.name}
                      </div>

                    </div>

                    <div className="info-row">

                      <div
                        className="team-skill"
                        style={{
                          fontFamily: theme.typography.heading_font,
                        }}
                      >
                        {member.skill}
                      </div>

                      <div
                        className="team-exp"
                        style={{
                          fontFamily: theme.typography.text_font,
                        }}
                      >
                        {member.experience} Years Exp
                      </div>

                    </div>

                  </div>

                </div>

              </SwiperSlide>
            ))}

          </Swiper>

        </div>

      </div>

    </section>
  );
};

export default MeetTheTeam;